'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    LabelNode: ()=>LabelNode
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const index_cjs_namespaceObject = require("../../Text/index.cjs");
const external_PlainButton_index_cjs_namespaceObject = require("../../PlainButton/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../../Image/index.cjs");
const LabelNode = ({ disabled = false, facet, handleOnlyClick, helperText, iconName, imgSrc, imgAlt, label, showOnlyButton = false })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex w-full justify-between gap-2",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: "flex items-start gap-2",
                children: [
                    iconName ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                        iconName: iconName
                    }) : null,
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    imgSrc ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                                        src: imgSrc,
                                        alt: imgAlt ?? 'image',
                                        borderRadius: "none",
                                        maxWidth: 24,
                                        height: 5,
                                        objectFit: "contain",
                                        objectPosition: "center",
                                        width: "auto"
                                    }) : null,
                                    label ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.P, {
                                        children: label
                                    }) : null,
                                    showOnlyButton && !disabled ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_PlainButton_index_cjs_namespaceObject.PlainButton, {
                                        textStyle: "body3",
                                        type: "primary",
                                        onClick: handleOnlyClick,
                                        children: "Only"
                                    }) : null
                                ]
                            }),
                            helperText ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.P, {
                                textStyle: "body3",
                                children: helperText
                            }) : null
                        ]
                    })
                ]
            }),
            facet ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.P, {
                textStyle: "body3",
                palette: "primary",
                shade: "10",
                className: "pt-[2px] leading-normal",
                children: facet
            }) : null
        ]
    });
exports.LabelNode = __webpack_exports__.LabelNode;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "LabelNode"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
